<script setup lang="ts">
import router from "@/router";
import { ArrowRightIcon } from '@heroicons/vue/20/solid'

const props = defineProps<{
  title: string,
  description: string,
  route?: string,
  routeParams?: Record<string, string>,
  url?: string,
}>()

function click() {
  if (props.route) {
    router.push({
      name: props.route,
      params: props.routeParams || {},
    });
  } else if (props.url) {
    window.location.href = props.url;
  }
}
</script>

<template>
  <div @click="click" class="group link">
    <h2 class="mb-1 text-lg font-semibold flex items-center">
      <span class="mr-2">{{ title }}</span>
      <span class="inline-block transition-transform group-hover:translate-x-1 motion-reduce:transform-none">
        <ArrowRightIcon class="w-5 h-5"/>
      </span>
    </h2>
    <p class="m-0 max-w-[50ch] text-sm opacity-50">
      {{ description }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.link {
  @apply cursor-pointer block rounded-lg border px-5 py-4 transition-colors;
  @apply border-gray-300 dark:border-gray-600;
  @apply hover:border-gray-300 hover:bg-gray-100 hover:dark:border-neutral-700 hover:dark:bg-neutral-800/30;
}
</style>
